<template>
    <div class="flex gap-2 items-center box-border p-2 cursor-pointer text-sm transition-all">
        <input
            v-if="selectable"
            v-model="selected"
            :disabled="disabled"
            type="checkbox"
            class="flex-initial w-5 h-5 min-w-[1.25rem]"
            @change.native="handleCheckboxClick" >
        <div class="flex-1 gap-2 overflow-hidden">
            <div class="grid grid-cols-2 gap-2 overflow-hidden">
                <p class="font-bold whitespace-nowrap">
                    <span class="text-blue-500">
                        {{ journey?.code }}
                    </span>
                    <span class="mx-1">
                        &#45;
                    </span>
                    <hts-link
                        :to="{ name: 'trucker-id-order', query: { action: 'view', orderId: journey?.order } }"
                        target="_blank">
                        {{ journey?.orderCode }}
                    </hts-link>
                </p>
            </div>
            <div class="flex flex-wrap my-1">
                <hts-tooltip>
                    <template #reference>
                        <p class="truncate max-w-[290px]">
                            {{ CStageNames }}
                        </p>
                    </template>

                    <hts-stage-names :items="journey.stageNames" />
                </hts-tooltip>
            </div>
            <div class="flex items-center">
                <span class="text-green-600 whitespace-nowrap inline-block align-middle text-sm">
                    {{ $formatters.datetime(journey.timeIn) }}
                </span>
                <span class="mx-1">
                    &#45;
                </span>
                <span class="text-accent-600 whitespace-nowrap inline-block align-middle text-sm">
                    {{ $formatters.datetime(journey.timeOut) }}
                </span>
            </div>
        </div>
        <div class="flex-initial">
            <slot name="actions" />
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  journey: {
    type: Object,
    default: () => ({})
  },
  selectable: Boolean,
  selectedItems: {
    type: Array,
    default: () => []
  },
  disabled: Boolean
})
const emits = defineEmits(['change'])

const { selectable, journey, selectedItems } = toRefs(props)
const parentSelected = computed(() => {
  return selectedItems.value.includes((journey as any)?.value?.id)
})
const selected = ref(false)

const CStageNames = computed(() => {
  if (!Array.isArray(journey.value.stageNames) || !journey.value.stageNames.length) {
    return ''
  }

  return journey.value.stageNames.join(' > ')
})

watch(
  () => parentSelected.value,
  (val: boolean) => {
    if (selected.value !== val) {
      selected.value = val
    }
  }
)

const handleCheckboxClick = (e: any) => {
  emits('change', selected.value)
}
</script>
